import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device } from '@helpers/media';
import { h6, paragraphSmall } from '@helpers/typography';
import { horizontalFadeIn, staggerChildren, verticalFadeIn } from '@helpers/variants';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
import { PillStyles } from '../../Pill/Pill.styles';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
const Container = styled(m.div).attrs(({ inView }) => ({
    initial: 'hidden',
    animate: inView ? 'visible' : 'hidden',
})) `
  ${({ variant }) => variant === 'buff'
    ? css `
          --cardTheme: ${brand.buff.buff4};
        `
    : css `
          --cardTheme: ${brand.tertiary.pinkAlt};
        `}

  ${() => PillStyles.Container} {
    background-color: ${({ variant }) => variant === 'buff' ? brand.secondary.red5 : brand.secondary.red3};
  }

  border-radius: 16px;
  background-color: ${brand.white};
  border: 4px solid var(--cardTheme);
  display: grid;
  grid-template-rows: auto 1fr;
  max-width: 390px;
  overflow: hidden;
  margin: auto;
`;
const ImageWrapper = styled(m.div).attrs(() => ({
    variants: {
        hidden: {
            opacity: 0,
            scale: 0.98,
        },
        visible: {
            opacity: 1,
            scale: 1,
        },
    },
    transition: {
        duration: 0.75,
    },
})) `
  ${imageWrapperPreserveRatio(5, 3)}
  position: relative;
  width: 100%;
  overflow: hidden;

  img {
    ${imageCoverContainer()}
    pointer-events: none;
  }
`;
const ContentWrapper = styled(m.div).attrs(() => ({
    variants: staggerChildren(0.15),
})) `
  grid-row: span 3;
  border-top: 4px solid var(--cardTheme);
  display: flex;
  flex-direction: column;
  // prettier-ignore
  padding: ${fluidAdjusted(20, 22, Device.Mobile, Device.ActualDesktop)} ${fluidAdjusted(24, 32, Device.Mobile, Device.ActualDesktop)};
`;
const CategoryPill = styled.div `
  ${PillStyles.Container} {
    font-size: ${fluidAdjusted(12, 13)};
    line-height: ${fluidAdjusted(18, 19)};
    letter-spacing: -0.024em;
    padding: 6px 12px 7px;
  }
`;
const TopContentRow = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(-25),
})) `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
`;
const Date = styled.div `
  ${paragraphSmall};
  font-weight: 900;
`;
const Title = styled(m.div).attrs(() => ({
    variants: horizontalFadeIn(-25),
})) `
  ${h6}
`;
const Content = styled(m.div).attrs(() => ({
    variants: horizontalFadeIn(-25),
})) `
  ${paragraphSmall}

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ButtonContainer = styled(m.div).attrs(() => ({
    variants: horizontalFadeIn(-25),
})) `
  margin-top: auto;
`;
export const NewsCardStyles = {
    Container,
    ImageWrapper,
    ContentWrapper,
    CategoryPill,
    TopContentRow,
    Date,
    Title,
    Content,
    ButtonContainer,
};
